export enum ClosedCaseVisibility {
  OpenToEveryone = 0,
  RestrictedToAssignedTeams = 1,
}
